export default __webpack_public_path__ + "static/media/redux.7fe607aa.svg";